import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { Button } from '@/components/v2/ui'
import { useAdoptListingRemake } from '@/hooks/useListingBuilder'
import { EID } from '@/lib/element-ids.registry'

interface AdoptRemakeButtonProps {
  remakeId: string
}

/** Übernimmt die Jury-Textvariante eines Remakes in content_blocks (P6-MUSS). */
export function AdoptRemakeButton({ remakeId }: AdoptRemakeButtonProps) {
  const { t } = useTranslation()
  const adopt = useAdoptListingRemake()

  const handleClick = () => {
    adopt.mutate(remakeId, {
      onSuccess: () => toast.success(t('listingBuilder.remake.adoptSuccess')),
      onError: () => toast.error(t('listingBuilder.remake.adoptError')),
    })
  }

  return (
    <Button
      id={EID['listing-builder-remake-adopt-btn']}
      type="button"
      variant="outline"
      disabled={adopt.isPending}
      onClick={handleClick}
    >
      {t('listingBuilder.remake.adoptButton')}
    </Button>
  )
}
